import { ja as ja$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var ja = {
  language: 'ja',
  country: 'jp',
  name: '日本語',
  embeddedLocale: merge(error, login),
  flags: ['JP'],
  dateFns: ja$1,
  format: {
    date: 'yyyy/MM/dd',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { ja as default };
